import { useState } from "react";
import { useTranslation } from "react-i18next";
import { css } from "../../../styled-system/css";
import { Flex } from "../../../styled-system/jsx";
import { Button } from "../../components/core/basic/Button";
import { TextField } from "../../components/fields/base/TextField";

export function IgnoreWarningsConfirmation({
  confirmationPhrase,
  onConfirm,
  isDisabled,
}: {
  confirmationPhrase: string;
  onConfirm: () => void;
  isDisabled?: boolean;
}) {
  const { t } = useTranslation(["uploads"]);
  const [value, setValue] = useState("");

  return (
    <>
      <p>
        {t(
          ($) =>
            $.uploads.confirmation['To proceed without fixing these, type "{confirmationPhrase}" in the box below'],
          {
            confirmationPhrase,
          },
        )}
      </p>
      <TextField placeholder={confirmationPhrase} value={value} onChange={setValue} />
      <Flex className={css({ width: "100%" })} justifyContent="center">
        <Button onPress={onConfirm} isDisabled={value.toLowerCase() !== confirmationPhrase.toLowerCase() || isDisabled}>
          {t(($) => $.uploads.confirmation["Ignore Warnings"])}
        </Button>
      </Flex>
    </>
  );
}
